import { useEffect } from 'react';
import { useWatch } from 'react-hook-form';
import { useSelectedEnterpriseIdsContext } from '../contexts/SelectedEnterpriseIdsContext';
import { useIntersectingServicesSuspenseQuery } from '../queries/intersectingServices';
import { RateGroupFormValues } from '../schemas/rateGroupFormSchema';

export const useResetIfInactive = ({ active, reset }: { active: boolean | undefined; reset: () => void }) => {
    useEffect(() => {
        if (!active) {
            reset();
        }
    }, [active, reset]);
};

export const useSelectedService = () => {
    const serviceKey: string = useWatch<RateGroupFormValues>({
        name: 'serviceKey',
    });

    const { enterpriseIds } = useSelectedEnterpriseIdsContext();
    const { intersectingServices } = useIntersectingServicesSuspenseQuery({
        enterpriseIds,
    });

    return intersectingServices.find((service) => service.externalIdentifier === serviceKey);
};
